import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { getSessionId } from '../session/session-id';

export const DomainEventType = {
  LoaderVisible: 'loader:visible',
  PaymentPageReady: 'payment:page.ready',
  PaymentSubmit: 'payment:submit',
  PaymentStatusFirstHandled: 'payment:status.first_handled',
  SignalrState: 'signalr:state',
  SignalrPollIteration: 'signalr:poll.iteration',
  ErrorPageShown: 'error:page.shown',
  NotFoundPageShown: 'not_found:page.shown',
  PaymentApiInitiateEnd: 'payment:api.initiate.end',
  PaymentApiStatusCheckEnd: 'payment:api.status.end',
  PaymentApiGetRequestEnd: 'payment:api.get_request.end',
  PspRedirectHandoff: 'payment:psp.redirect.handoff'
} as const;

export type DomainEventPayload =
  | { type: typeof DomainEventType.LoaderVisible; visible: boolean }
  | { type: typeof DomainEventType.PaymentPageReady; publicId: string }
  | { type: typeof DomainEventType.PaymentSubmit; publicId: string; correlationId: string }
  | { type: typeof DomainEventType.PaymentStatusFirstHandled; publicId: string; correlationId: string; status: string; requestStatus: string }
  | { type: typeof DomainEventType.SignalrState; state: 'reconnecting' | 'reconnected' | 'connected' | 'closed' }
  | { type: typeof DomainEventType.SignalrPollIteration; iteration: number }
  | { type: typeof DomainEventType.ErrorPageShown; publicId: string | null; status?: string; url?: string }
  | { type: typeof DomainEventType.NotFoundPageShown; url?: string }
  | { type: typeof DomainEventType.PaymentApiInitiateEnd; publicId: string; correlationId: string; ok: boolean; error?: { name?: string; message?: string; status?: any } }
  | { type: typeof DomainEventType.PaymentApiStatusCheckEnd; publicId: string; correlationId: string; ok: boolean; error?: { name?: string; message?: string; status?: any } }
  | { type: typeof DomainEventType.PaymentApiGetRequestEnd; publicId: string; ok: boolean; cache?: 'hit' | 'miss'; error?: { name?: string; message?: string; status?: any } }
  | { type: typeof DomainEventType.PspRedirectHandoff; publicId: string; correlationId: string; url: string };

export type DomainEvent = DomainEventPayload & { sessionId: string; timestamp: number };

@Injectable({ providedIn: 'root' })
export class DomainEventBus {
  private subject = new Subject<DomainEvent>();
  public readonly events$: Observable<DomainEvent> = this.subject.asObservable();

  emit(event: DomainEventPayload | DomainEvent) {
    const withSession = { ...(event as DomainEventPayload), sessionId: getSessionId(), timestamp: Date.now() } as DomainEvent;
    this.subject.next(withSession);
  }
}
